import S from 'common/service/sanctuary';
import { combineEpics, ofType } from 'redux-observable';
import { map, catchError, switchMap, startWith, mergeMap } from 'rxjs/operators';
import { prop } from 'ramda';
import * as R from 'ramda';
import { addNotification, replaceNotification } from 'common/mdc/notifications/actions';
import {
  TYPE_SUCCESS, TYPE_ERROR, TYPE_PENDING,
} from 'common/mdc/notifications/notification';
import { Subject, merge, of } from 'rxjs';
import { PublicError } from 'common/service/error';
import { createErrorStream } from 'common/store/error';
import {
  LOAD_ALL, loadAll, loadAllSuccess, loadAllError,
  UPDATE_ALL, PAGINATION_CHANGE,
  DOWNLOAD_ALL, downloadAll, downloadAllSuccess, downloadAllError,
  TOGGLE_SORT,
  SELECT_PROFILE,
  setRegisters,
} from './actions';

import {
  getDeviceId,
} from '../meteringProfile/selectors';

import {
  getStoreParams,
  getMeteringProfileId,
  getMeteringProfile,
} from './selectors';

const successText = (response) => {
  switch (response.status) {
    case 206:
      return "Meter sample data partially downloaded";
    default:
      return "Meter sample data downloaded";
  }
};

const loadAllEpic = (action, state, { deviceService }) => action.pipe(
  ofType(LOAD_ALL),
  switchMap(action$ => deviceService
    .getMeteringProfileSamples(
      action$.deviceId,
      action$.meteringProfileId,
      getStoreParams(state.value),
    )
    .pipe(
      map(loadAllSuccess),
      catchError(createErrorStream(action$, loadAllError)),
    )),
);

const downloadAllEpic = (action, state, { deviceService }) => action.pipe(
  ofType(DOWNLOAD_ALL),
  mergeMap((action$) => {

    const pendingNotification = addNotification({
      autoHide: false,
      type: TYPE_PENDING,
      text: "Meter sample data download in progress"
    });
    const failureMessage = "";

    return deviceService
    .downloadMeteringProfileSamples(
      S.maybeToNullable(getDeviceId(state.value)),
      S.maybeToNullable(getMeteringProfile(state.value)),
      getStoreParams(state.value),
    )
      .pipe(
        mergeMap((response) => of(
          replaceNotification(pendingNotification.notification, {
            type: TYPE_SUCCESS,
            autoHide: true,
            text: successText(response),
          }),
        )),
        startWith(pendingNotification),
        catchError(createErrorStream(
          action$,
          err => replaceNotification(pendingNotification.notification, {
            type: TYPE_ERROR,
            autoHide: true,
            text: R.is(PublicError, err) && err.message
                ? err.message
                : err.status === 429 ? "Too many requests. Please try again later." : failureMessage,
          }),
        )),
      );
  }),
);

const updateAllEpic = (action, state) => action.pipe(
  ofType(UPDATE_ALL, TOGGLE_SORT, PAGINATION_CHANGE, SELECT_PROFILE),
  map(() => (
    loadAll(
      S.maybeToNullable(getDeviceId(state.value)),
      S.maybeToNullable(getMeteringProfileId(state.value)),
    )
  )),
);

const selectProfileEpic = (action, state) => action.pipe(
  ofType(SELECT_PROFILE),
  map(() => setRegisters(
    S.maybe([], prop('registers'), getMeteringProfile(state.value)),
  )),
);

export default combineEpics(
  loadAllEpic,
  downloadAllEpic,
  updateAllEpic,
  selectProfileEpic,
);
